import { getBasicDineData } from '@/services';
import { setBasicDineData, setHomeLoader, setLocationData } from '@/store/basicData/basicDataSlice';
import { setUserAddress, setUserData } from '@/store/userData/userDataSlice';
import { getDineConfigSession, setCartConfigSession } from '@/utils';
import { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import useSetupGAnalytics from './useSetupGAnalytics';
import useSetupFAnalytics from './useSetupFAnalytics';

export const useBasicDineData = () => {
	const dispatch = useDispatch();
	const setupGAnalytics = useSetupGAnalytics();
	const setupFAnalytics = useSetupFAnalytics();

	useLayoutEffect(() => {
		getDineData();
	}, []);

	const getDineData = async () => {
		const { status, data } = await getBasicDineData();
		if (status === 200) {
			setCartConfigSession(
				data?.cartConfig ?? {
					pos_basket_Delivery_Type: 'Collection',
					pos_basket_Payment_Type: 'Card',
					pos_basket_Id: 0
				}
			);
			if (data?.customer?.length) {
				dispatch(setUserData(data?.customer));
			}
			if (data?.customer?.common_customer_Address?.length) {
				dispatch(
					setUserAddress({
						selected: data?.customer?.common_customer_Address[0],
						address: data?.customer?.common_customer_Address
					})
				);
			}
			dispatch(setBasicDineData(data));
			dispatch(
				setLocationData(
					getDineConfigSession()?.locationData ?? {
						latitude: '53.048988',
						longitude: '-2.198013',
						cityName: 'Stoke-on-trent',
						street: 'Scotia Road',
						county: '',
						frm: 'addr',
						postcodePretty: 'st6 4ep'
					}
				)
			);
			setupGAnalytics(data);
			setupFAnalytics(data);

            // for store page loader will not be turned off here because after loading initial data we need some more data to load so we will turn off loader in that place
			const path = window.location?.pathname || '';
			const isStoresPage = path.startsWith('/stores');
			if (!isStoresPage) {
					dispatch(setHomeLoader(false));
			}
		}
	};
};
